<template>
  <div>
    <a-card class="order-detail-content">
      <div class="order-detail-title-border">
        <div class="order-detail-content-title">
          {{ $t('returnBoxApply') }}
          <span style="color: #333333;font-size: 12px;">{{ $t('returnBoxTimeHint') }}</span>
        </div>
        <a-button class="order-detail-content-add_button" v-if="cityOptions.length > 0" @click="open()">
          <a-icon type="plus"/>
          {{ $t('applyRerunBox') }}
        </a-button>
      </div>
      <div v-if="showData.length > 0">
        <dol-row class="order-detail-content-border" v-for="(item,index) in showData" :key="index">
          <dol-col :span="8" class="order-detail-content-left">
            <div class="order-detail-content-city order-detail-content-date">{{ $t('planReturnBoxTime') }}:</div>
            <div class="order-detail-content-box">{{
                $moment(item.BEGIN_DATE).format('MM-DD')
              }}~{{ $moment(item.END_DATE).format('MM-DD') }}
            </div>
            <!--              <div class="order-detail-content-city">【{{ item.CITY_NAME }}】{{ item.SPACE_NAME }}</div>-->
          </dol-col>
          <dol-col :span="10" style="display: flex;">
            <div v-for="(code,index) in item.BOX_CODE_ARR" :key="index">
              <a-tag style="margin: 3px" color="blue">
                {{ code.BOX_CODE }}
              </a-tag>
            </div>
          </dol-col>
          <dol-col :span="6">
          </dol-col>
        </dol-row>
      </div>

      <a-empty :description="false" v-else/>
    </a-card>

    <!--  还箱申请  -->
    <a-modal
      v-model="visible"
      centered
      width="60%"
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
      :title="$t('returnBoxApply')"
      @ok="confirm"
      @cancel="cancel"
    >
      <dol-form-model
        :model="editForm"
        :rules="editRule"
        ref="editForm"
      >
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('city')" prop="D_CITY_ID">
          <dol-select
            v-model="editForm.D_CITY_ID"
            source="local"
            :default-data="cityOptions"
            :label-field="$kt('CITY_NAME')"
            key-field="CITY_ID"
            value-field="CITY_ID"
            :disabled="cityOptions.length === 1"
            @change="pickReturnCity"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('planReturnBoxTime')" :labelCol="{span: 24}" required :wrapperCol="{span: 24}">
          <a-form-model-item :style="{ display: 'inline-block'}" prop="BEGIN_DATE">
            <dol-date :placeholder="$t('pleaseSelectADate')" v-model.trim="editForm.BEGIN_DATE" @change="pickBeginDate"/>
          </a-form-model-item>
          ~
          <a-form-model-item :style="{ display: 'inline-block', width: '183px' }" prop="END_DATE">
            <dol-date :placeholder="$t('pleaseSelectADate')" v-model.trim="editForm.END_DATE"/>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="BOX_ARR">
          <template #label>
            <span>{{ $t('pleaseSelectTheCaseNumber') }}</span>
            <a-checkbox v-model="checkAllFlag" @change="checkAll">{{ $t('selectAll') }}</a-checkbox>
          </template>
          <div class="form-box-options">
            <div style="margin-bottom: 12px">
              {{ $t('total') }}{{ boxOptions.length }}{{ $t('containersCanBeReturnedPleaseSelect') }}
            </div>
            <a-checkbox-group v-model.trim="editForm.BOX_ARR" :options="boxOptions"></a-checkbox-group>
          </div>
        </a-form-model-item>
      </dol-form-model>
    </a-modal>
  </div>
</template>

<script>
import CitySelect from '@/components/contcircle/form/city-select.vue';

export default {
  name: 'apply-return-list',
  components: { CitySelect },
  props: {
    sheetData: {type: Object}, // 完整表单数据
    orderForm: {type: Object}, // 处理后的，主单数据
    showData: {type: Array}, // 处理后的，还箱申请数据
    boxList: {type: Array}, // 全部箱列表
  },
  data () {
    return {
      loading: false,
      visible: false,
      editForm:{ BOX_ARR: [] },
      boxOptions: [],

      boxInfoMap: {},
      checkAllFlag: false,
    };
  },
  computed: {
    columns() {
      let columns = [];
      columns.push({dataIndex: 'SHEET_CODE', title: this.$t('returnApplyOrderNumber')});
      columns.push({dataIndex: 'BEGIN_DATE', title: this.$t('planReturnBoxTime'), scopedSlots: {customRender: 'date'}});
      // columns.push({dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$t('boxSize')});
      columns.push({dataIndex: this.$kt('D_CITY_NAME'), title: this.$t('city')});
      columns.push({dataIndex: 'BOX_CODE_ARR', title: this.$t('通用_箱号'), scopedSlots: {customRender: 'array'}});
      return columns;
    },
    editRule(){
      return {
        BEGIN_DATE: [{required: true, message: this.$t('pleaseSelectAStartTime'), trigger: ['blur', 'change']}],
        END_DATE: [{required: true, message: this.$t('pleaseSelectAnEndTime'), trigger: ['blur', 'change']}],
        BOX_ARR: [{required: true, message: this.$t('pleaseSelectTheBox'), trigger: ['blur', 'change']}],
        D_CITY_ID: [{required: true, message: this.$t('租赁单_请选择还箱城市'), trigger: ['blur', 'change']}],
      }
    },
    cityOptions(){
      if(!this.sheetData.OT_XG_DETAIL || !this.sheetData.BOX_LIST){
        return [];
      }

      const hasApplyReturnBoxMap = {};
      this.sheetData.OT_XG_DETAIL.forEach(item => {
        hasApplyReturnBoxMap[item.BOX_ID] = item;
      });
      const toApplyReturnBox = this.sheetData.BOX_LIST.filter(item => !hasApplyReturnBoxMap[item.BOX_ID]);
      if(toApplyReturnBox.length === 0){
        return [];
      }

      const diffCityReturnMap = {};
      this.sheetData.XG_APPLY_LIST.forEach(item => {
        if(item.STATUS !== 5){
          return true;
        }
        diffCityReturnMap[item.BOX_ID] = item;
      });

      const cityOptions = [], cityMap = {};
      toApplyReturnBox.forEach(item => {
        const cityInfo = {};
        if(diffCityReturnMap[item.BOX_ID]){
          cityInfo.CITY_ID = diffCityReturnMap[item.BOX_ID].CITY_ID;
          cityInfo.CITY_NAME = diffCityReturnMap[item.BOX_ID].CITY_NAME;
          cityInfo.CITY_NAME_ENG = diffCityReturnMap[item.BOX_ID].CITY_NAME_ENG;
          cityInfo.CITY_NAME_RUS = diffCityReturnMap[item.BOX_ID].CITY_NAME_RUS;
        }else{
          cityInfo.CITY_ID = this.sheetData.OT_XB_MASTER[0].D_CITY_ID;
          cityInfo.CITY_NAME = this.sheetData.OT_XB_MASTER[0].D_CITY_NAME;
          cityInfo.CITY_NAME_ENG = this.sheetData.OT_XB_MASTER[0].D_CITY_NAME_ENG;
          cityInfo.CITY_NAME_RUS = this.sheetData.OT_XB_MASTER[0].D_CITY_NAME_RUS;
        }
        if(!cityMap[cityInfo.CITY_ID]){
          cityMap[cityInfo.CITY_ID] = {
            ...cityInfo,
            boxOptions: [],
          }
          cityOptions.push(cityMap[cityInfo.CITY_ID]);
        }
        cityMap[cityInfo.CITY_ID].boxOptions.push({ value: item.BOX_ID, label: item.BOX_CODE });
      });
      return cityOptions;
    },
  },
  methods: {
    open() {
      if(this.loading){
        return false;
      }
      let condition = { MASTER_ID: this.orderForm.MASTER_ID };
      this.loading = true;
      this.$h5Api({ type: '4032', data: [condition] }).then(({data}) => {
        const boxInfoMap = {};
        data?.OT_XG_CREATE_INFO.forEach(item => {
          boxInfoMap[item.BOX_ID] = item;
        });
        this.boxInfoMap = boxInfoMap;

        this.$nextTick(() => {
          this.$set(this.editForm, 'D_CITY_ID', this.cityOptions[0].CITY_ID);
          this.pickReturnCity(this.cityOptions[0].CITY_ID, this.cityOptions[0]);
        });

        this.checkAllFlag = false;
        this.visible = true;
      }).finally(() => {
        this.loading = false;
      })
    },
    checkAll(e) {
      let BOX_ARR = [];
      if(e.target.checked) this.boxOptions.forEach(item => BOX_ARR.push(item.value));
      this.$set(this.editForm, 'BOX_ARR', BOX_ARR);
    },
    confirm(){
      if(this.loading){
        return false;
      }

      this.$refs.editForm.validate(val => {
        if(!val){
          return true;
        }

        let submitData = {};
        let OT_XG_INFO = [];
        this.editForm.BOX_ARR.forEach(item => {
          const boxInfo = this.boxInfoMap[item];
          if(!boxInfo){
            return true;
          }
          OT_XG_INFO.push({
            "VOUCHER_ID": boxInfo.VOUCHER_ID,
            "TARGET_ID": boxInfo.TARGET_ID,
            "PARENT_FLOW_ID": boxInfo.PARENT_FLOW_ID,
            "BOX_FLOW_ID": boxInfo.BOX_FLOW_ID,
            "BOX_ID": boxInfo.BOX_ID,
            "BEGIN_DATE": this.$moment(this.editForm.BEGIN_DATE).format('YYYY-MM-DD'),
            "END_DATE": this.$moment(this.editForm.END_DATE).format('YYYY-MM-DD'),
            XD_MASTER_ID : boxInfo.XD_MASTER_ID,
            XD_SHEET_CODE : boxInfo.XD_SHEET_CODE,
            D_CITY_ID: this.editForm.D_CITY_ID,
          })
        })
        submitData.OT_XG_INFO = OT_XG_INFO;
        this.loading = true;
        this.$h5Api({
          type: '4033',
          data: [submitData],
        }).then(() => {
          this.visible = false;
          this.$message.info(this.$t('operateSuccessfully'));
          this.$emit('reload');
        }).finally(() => {
          this.loading = false;
        })
      })
    },
    cancel() {
      this.editForm = { BOX_ARR: [], };
      this.visible = false;
    },
    pickBeginDate(){
      if(this.editForm.BEGIN_DATE && !this.editForm.END_DATE) {
        this.$set(this.editForm, 'END_DATE', this.$moment(this.editForm.BEGIN_DATE).add(7, 'day').format('YYYY-MM-DD'));
      }
    },
    pickReturnCity(v, o){
      this.boxOptions = o.boxOptions;
    },
  }
};
</script>

<style lang="scss">

</style>
